<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.hide()"><span aria-hidden="true">&times;</span></button>
    <h3 class="modal-title">Indicadores</h3>
  </div>
  <div class="modal-body">
    <section class="content">
      <div class="info">
        <span class="info-title">Indice Liquidez Seca
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"(Ativo Disponível + Contas a receber) / (Passivo Circulante + Empréstimos) (ideal > 1)"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.indiceLiquidezSeca | number:'1.2-5' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Indice Liquidez Corrente
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"(Ativo Disponível + Contas a receber + Estoque de Produtos e matéria-prima ) / (Passivo Circulante + Empréstimos) (ideal > 1 )"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.indiceLiquidezCorrente | number:'1.2-5' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Indice Liquidez imediata
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Ativo Disponível / (Passivo Circulante + Empréstimos) (ideal > 1)"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.indiceLiquidezImediata | number:'1.2-5' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Percentual de Endividamento
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"(Passivo Circulante + Empréstimos) / TOTAL DO ATIVO (ideal < 50%)"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.percentualEndividamento | number:'1.2-2' }}%</span>
      </div>
      <div class="info">
        <span class="info-title">ROA (Retorno sobre ativos)
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Resultado Líquido do Empreendimento / TOTAL DO ATIVO"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.roa | number:'1.2-3' }}</span>
      </div>
      <div class="info">
        <span class="info-title">ROE (Retorno sobre patrimônio)
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Resultado Líquido do Empreendimento / Patrimonio líquido"'></saiba-mais>
        </span>
        <span class="info-value">{{ model.roe | number:'1.2-3' }}</span>
      </div>
    </section>
  </div>
  <div class="modal-footer centered">
    <button class="btn btn-border-orange" (click)="modal.hide()">Fechar</button>
  </div>
</div>
